import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'gamification-header',
  templateUrl: 'gamification-header.component.html',
  styleUrls: ['gamification-header.component.scss'],
})
export class GamificationHeaderComponent implements OnInit {
  @Output() onGrabMovement = new EventEmitter<any>();

  ngOnInit() {}

  grabMovement() {
    this.onGrabMovement.emit();
  }
}
